export default "__VITE_ASSET__vEC9pluh__"